import { render, staticRenderFns } from "./InstallmentBatchTypeDelete.vue?vue&type=template&id=d972e6e8&"
import script from "./InstallmentBatchTypeDelete.vue?vue&type=script&lang=js&"
export * from "./InstallmentBatchTypeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports